import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, Users, Folder, User, AppWindow, BarChart3, HelpCircle } from "lucide-react";

const isActive = (p: string, t: string) => p === t || p.startsWith(t + "/");

export function MobileNav() {
  const { pathname } = useLocation();
  
  const navItems = [
    { to: "/app", icon: LayoutDashboard, label: "Início", exact: true },
    { to: "/app/pacientes", icon: Users, label: "Pacientes" },
    { to: "/app/aplicativos", icon: AppWindow, label: "Apps" },
    { to: "/app/estatisticas", icon: BarChart3, label: "Estatíst." },
    { to: "/app/categorias", icon: Folder, label: "Categ." },
    { to: "/app/minha-conta", icon: User, label: "Conta" },
    { to: "/app/suporte", icon: HelpCircle, label: "Suporte" },
  ];

  return (
    <nav
      className="
        fixed bottom-0 inset-x-0 z-40 lg:hidden
        bg-card/90 backdrop-blur border-t border-border shadow-soft
        px-1
      "
      role="navigation"
      aria-label="Menu móvel"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <ul className="grid grid-cols-7 items-center h-16">
        {navItems.map((item) => (
          <li key={item.to} className="flex justify-center">
            <Link
              to={item.to}
              className={`flex flex-col items-center gap-0.5 ${
                (item.exact ? pathname === item.to : isActive(pathname, item.to))
                  ? "text-primary"
                  : "text-muted-foreground"
              }`}
            >
              <item.icon className="h-4 w-4" />
              <span className="text-[10px]">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

